export async function deregOfServiceWorker(){
    const registration = await navigator.serviceWorker.getRegistration();
    let displayCacheLog = false;
    try {
        displayCacheLog = process.env.SHOW_CACHE_LOG
            ? JSON.parse(process.env.SHOW_CACHE_LOG.toLowerCase())
            : false;
    } catch (error) {
        displayCacheLog = false;
    }
    const enviromentConsole = process.env.mod?.toLowerCase() === 'development';
    
    if(enviromentConsole) {
        console.log('%cNon - Prod Build has been loaded', 'background: #f3f3f3; color: red; font-size: 32px; padding: 8px 16px; margin: 8px 0; font-weight: bold;');
    }

    if (registration) {
        // Check if the service worker is 'sw1'
        const isSw1 = registration.active && 
                      registration.active.scriptURL && 
                      registration.active.scriptURL.includes('sw1.js');
        
        if (isSw1) {
            await registration.unregister();
            if (displayCacheLog) console.log('%c[SW]%c Service worker sw1 unregistered','background:green; color:#f3f3f3; font-weight: bold; padding: 0 8px', '');
        }
    }
}